<template>
    <div class="youBox">
        <div class="fl youLeft">
            <div :class="tabIndex==index?'active':'moren'" v-for="(item,index) in list" :key="index" @click="changState(index)">
                <span>{{item.title}}</span>
                <img class="leftBg" v-if="tabIndex==index" src="@/assets/cooperate/leftBg.png" alt="">
            </div>
        </div>
        <div class="fr youRight">
            <div class="tabC1" v-if="tabIndex==0">
                <p>瑞和安惠项目管理集团创建于2000年。</p>
                <p>集PPP咨询、投资咨询、造价咨询、招标采购、管理咨询、BIM应用及IPMP项目管理培训于一体的全过程工程咨询企业。</p>
                <p>凭借多项甲级资质以及成熟的信息化技术，构建了完整的全过程工程咨询业务链。</p>
            </div>
            <div class="" v-if="tabIndex==1">
                <div class="tabC2">
                    <div class="monBox">
                        <p class="money">5000万元</p>
                        <p class="desc">注册资金</p>
                    </div>
                    <div class="monBox">
                        <p class="money">240余人</p>
                        <p class="desc">各类注册师</p>
                    </div>
                    <div class="monBox">
                        <p class="money">200余人</p>
                        <p class="desc">中高级职称</p>
                    </div>
                </div>
                <div class="tabC2">
                    <div class="monBox">
                        <p class="money">40余个</p>
                        <p class="desc">分支机构</p>
                    </div>
                    <div class="monBox">
                        <p class="money">5000余项</p>
                        <p class="desc">年均项目</p>
                    </div>
                    <div class="monBox">
                        <p class="money">超2亿元</p>
                        <p class="desc">年总产值</p>
                    </div>
                </div>
            </div>
            <div class="tabC1" v-if="tabIndex==2">
                <p>20多年风雨兼程、拼搏进取，瑞和安惠秉承“诚信至高处、服务无限时”的服务宗旨；</p>
                <p>形成了总计 93 项的产品体系：<br>其中包括投资咨询 70 项；招标咨询 6 项；造价咨询  7 项；管理咨询 4  项； BIM咨询 6 项 。</p>
            </div>
            <div class="tabC1" v-if="tabIndex==3">
                <p>投资咨询： <br>中国工程咨询协会核发的综合甲级资信、①建筑，②电子、信息工程（含通信、广电、信息化）， ③石化、化工、医药，④机械（含智能制造），⑤轻工、纺织， ⑥市政工程等六个专业甲级资信；<br>①生态建设工程和环境工程，②农业、林业，③水利水电，④电力（含火电、水电、核电、新能源），⑤建材， ⑥其他（节能）等六项专业乙级资信；</p>
                <p>PPP咨询：中国工程咨询协会核发的政府和社会资本合作（PPP）咨询专项甲级资信；</p>
                <p>造价咨询：中华人民共和国住房和城乡建设部核发的工程造价咨询甲级资质；</p>
                <p>招标采购：建设工程、政府采购、中央投资、国际招标等招标代理甲级资质；</p>
                <p>工程监理：中华人民共和国住房和城乡建设部核发的房屋建筑工程监理甲级资质及河北省住房和城乡建设厅核发的市政公用工程监理乙级资质。</p>
            </div>
            <div class="tabC1" v-if="tabIndex==4">
                <p>专业人才团队，行业专家保障；</p>
                <p>瑞和安惠拥有结构合理、学历高、技术水平强、经验丰富的工程 咨询职业化技术团队，<br>并有一支由近200名省内各学科知名学者和工程技术人员组成的专家队伍；</p>
                <p>各类注册师240余人：<br>其中 注册一级造价师 30余人， 注册咨询师 50余 人， 各专业均配备齐全；</p>
                <p>中高级职称200余人，以上注册类人员均有中高级以上职称。</p>
            </div>
            <div class="tabC3" v-if="tabIndex==5">
                <div>河北省诚信共建企业</div>
                <div>2023年度市信用协会信用评价3A</div>
                <div>河北省守合同重信用企业</div>
                <div>省信用协会信用评价AAA等级证书</div>
                <div>河北省AAA级信用企业</div>
                <div>质量、安全、职业健康管理体系证书（2023）</div>
                <div>石家庄市守合同重信用企业</div>
                <div>中国建设工程造价管理协会3A信用等级证书</div>
                <div>石家庄市工商守合同重信用企业</div>
                <div>石家庄市工商行政管理局重合同守信用企业</div>
                <div>河北省计价信用承诺评选AAAAA级单位</div>
                <div>2021年中招协3A</div>
            </div>
            <div class="tabC4" v-if="tabIndex==6">
                <div><span class="yuand"></span> 出版“工程咨询理论与实践研究系列丛书”：</div>
                <p class="pl20">电子招标投标系统研究与实践</p>
                <p class="pl20">工程咨询企业项目管理办公室（PMO）理论与实践</p>
                <p class="pl20">工程咨询企业信息化管理实务</p>
                <p class="pl20">工程总承包管理理论实务</p>
                <p class="pl20">建设项目全过程投资控制理论与操作指南</p>
                <p class="pl20">企业项目化管理理论与实践</p>
                <p class="pl20">全过程工程咨询理论与实践指南</p>
                <p class="pl20">政府和社会资本合作（ppp）项目绩效评价实施指南</p>
                <p class="pl20">政府和社会资本合作（ppp）项目实施指南</p>
                <p class="pl20">重大投资项目社会稳定风险评估研究与实践</p>
                <div class="mt20"><span class="yuand"></span> 编制“全过程工程咨询（PMC）管理办法”</div>
                <div class="mt20"><span class="yuand"></span> 参编多项国家级及省级标准</div>
            </div>
            <div class="" v-if="tabIndex==7">
                <div class="tabC2">
                    <div>
                        <img src="@/assets/cooperate/baoz1.png" alt="">
                        <p>专业的服务团队</p>
                    </div>
                    <div>
                        <img src="@/assets/cooperate/baoz2.png" alt="">
                        <p>强大的技术支持</p>
                    </div>
                    <div>
                        <img src="@/assets/cooperate/baoz3.png" alt="">
                        <p>快速的响应机制</p>
                    </div>
                </div>
                <div class="tabC2">
                    <div>
                        <img src="@/assets/cooperate/baoz4.png" alt="">
                        <p>开放的资源共享</p>
                    </div>
                    <div>
                        <img src="@/assets/cooperate/baoz5.png" alt="">
                        <p>迅捷的数字赋能</p>
                    </div>
                    <div>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        data(){
            return{
                tabIndex:0,
                list:[
                    {
                        title:'全过程咨询优势'
                    },
                    {
                        title:'公司规模'
                    },
                    {
                        title:'业务产品体系优势'
                    },
                    {
                        title:'资质资信优势'
                    },
                    {
                        title:'人员优势'
                    },
                    {
                        title:'企业信誉优势'
                    },
                    {
                        title:'知识体系优势'
                    },
                    {
                        title:'服务保障'
                    }
                ],
            }
        },
        methods:{
             //切换分类
             changState(index){
                this.tabIndex= index
            },
        }
    }
</script>

<style scoped>
    .youBox{
        width: 1200px;
        height: 625px;
        background-color: #066EFC;
        border-radius: 10px;
        padding: 44px 53px 41px 52px;
    }
    .youLeft{
        width: 241px;
        height: 540px;
        background-color: #3B88FC;
    }
    .active{
        color: #004FFF;
        position: relative;
        height: 66px;
        line-height: 66px;
        padding-left: 23px;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
    }
    .active span{
        position: absolute;
        top: 0;
        left: 23px;
        width: 241px;
        height: 66px;
        z-index: 5;
    }
    .leftBg{
        position: absolute;
        top: 0;
        left: 0;
        width: 276px;
        height: 66px;
        z-index: 1;
    }
    .moren{
        color: #fff;
        border-bottom: 1px dotted #73AAFC;
        line-height: 66px;
        padding-left: 23px;
        font-weight: bold;
        font-size: 18px;
        cursor: pointer;
    }
    .moren:last-child{
        border: none;
    }
    .moren:hover{
        color: #004FFF;
    }
    .youRight{
        width: 802px;
        height: 540px;
        background: url('../../../assets/cooperate/rightBg.png');
        background-size: 100% 100%;
        padding: 41px 51px 41px 47px;
    }
    .tabC1{
        font-weight: bold;
        line-height: 30px;
    }
    .tabC1 p{
        margin-bottom: 20px;
    }
    .tabC2{
        display: flex;
        justify-content: space-between;
        margin-bottom: 49px;
    }
    .tabC2 div{
        width: 120px;
        font-weight: bold;
    }
    .tabC2 img{
        width: 100px;
        height: 100px;
        margin-bottom: 15px;
    }
    .tabC3{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
    .tabC3 div{
        width: 50%;
        font-weight: bold;
        margin-bottom: 20px;
    }
    .tabC4{
        font-weight: bold;
    }
    .tabC4 p{
        margin-top: 10px;
        padding-left: 26px;
    }
    .yuand{
        float: left;
        margin-top: 3px;
        margin-right: 10px;
        width: 16px;
        height: 16px;
        background: #066EFC;
        border-radius: 50%;
    }
    .monBox{
        width: 120px;
    }
    .money{
        font-size: 24px;
        color: #066EFC;
        margin-bottom: 10px;
    }
</style>